import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5b8f42e8&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8f42e8')) {
      api.createRecord('5b8f42e8', component.options)
    } else {
      api.reload('5b8f42e8', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5b8f42e8&", function () {
      api.rerender('5b8f42e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n937v0qYSzQl/JS/offershelp.vue"
export default component.exports